<script lang="ts">
    import type { Route } from "../global";
    import RouteMeasure from "./RouteMeasure.svelte";

    export let route: Route;
    export let size: string = '80px';

    $: show = !!(route.meta.longitude || route.meta.slope || route.meta.heightDiff);

</script>

{#if show}
    <div class="meta" style="--size: {size}">

        {#if route.meta.longitude}
            <div class="measure">
                <img class="icon" src="/images/distancia.svg" alt="Distancia">
                <div class="value">{`${route.meta.longitude}m`}</div>
            </div>
        {/if}
        {#if route.meta.slope}
            <div class="measure">
                <img class="icon" src="/images/pendiente.svg" alt="Pendiente">
                <div class="value">{`${route.meta.slope}%`}</div>
            </div>
        {/if}
        {#if route.meta.heightDiff}
            <div class="measure">
                <img class="icon" src="/images/desnivel.svg" alt="Desnivel">
                <div class="value">{`${route.meta.heightDiff}m`}</div>
            </div>
        {/if}

    </div>
{/if}

<style lang="scss">

    @use '../variables';

    .meta {
        --apply-size: var(--size, 80px);

        display: flex;
        gap: calc(var(--apply-size) * 0.05);
    }

    .measure {
        flex: 1 1 0;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: calc(var(--apply-size) * 0.05);
        color: #fff;
        background-color: variables.$color-primary;
        padding: calc(var(--apply-size) * 0.1);

        &:first-child {
            border-top-left-radius: calc(var(--apply-size) * 0.1);
            border-bottom-left-radius: calc(var(--apply-size) * 0.1);
        }

        &:last-child {
            border-top-right-radius: calc(var(--apply-size) * 0.1);
            border-bottom-right-radius: calc(var(--apply-size) * 0.1);
        }
    }

    .icon {
        $factor: 0.275;
        width: calc(var(--apply-size) * #{$factor});
        height: calc(var(--apply-size) * #{$factor});
        object-fit: contain;
    }

    .value {
        font-size: calc(var(--apply-size) * 0.15);
        font-weight: bold;
    }

    @media (min-width: 500px) {
        .icon {
            $factor: 0.375;
            width: calc(var(--apply-size) * #{$factor});
            height: calc(var(--apply-size) * #{$factor});
        }

        .value {
            font-size: calc(var(--apply-size) * 0.2);
        }
    }

</style>
